export const FLOWERS = ['🌼', '🌷', '🌻', '🌸', '🪻', '🌺'];

export function flowerForCriterion(criteria, criterionId) {
  const index = criteria.findIndex((criterion) => Number(criterion.id) === Number(criterionId));
  return index < 0 ? FLOWERS[0] : FLOWERS[index % FLOWERS.length];
}
